var _circle, _ellipse, _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgShoppingCartWhite(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "shopping-cart-add_1_",
    "data-name": "shopping-cart-add (1)",
    xmlns: "http://www.w3.org/2000/svg",
    width: 31.623,
    height: 32.12,
    viewBox: "0 0 31.623 32.12",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_11",
    "data-name": "Ellipse 11",
    cx: 2.425,
    cy: 2.425,
    r: 2.425,
    transform: "translate(7.051 27.271)",
    fill: "#fff"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_12",
    "data-name": "Ellipse 12",
    cx: 2.909,
    cy: 2.425,
    rx: 2.909,
    ry: 2.425,
    transform: "translate(19.658 27.271)",
    fill: "#fff"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_457",
    "data-name": "Path 457",
    d: "M25.223,3.953H22.588V1.318a1.318,1.318,0,1,0-2.635,0V3.953H17.318a1.318,1.318,0,0,0,0,2.635h2.635V9.223a1.318,1.318,0,0,0,2.635,0V6.588h2.635a1.318,1.318,0,0,0,0-2.635Z",
    transform: "translate(5.082)",
    fill: "#fff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_458",
    "data-name": "Path 458",
    d: "M28.686,12.815a1.31,1.31,0,0,0-1.531,1.062,3.953,3.953,0,0,1-3.89,3.252H7.139L5.9,6.588H17.129a1.318,1.318,0,1,0,0-2.635H5.589l-.055-.464A3.953,3.953,0,0,0,1.61,0H1.318a1.318,1.318,0,0,0,0,2.635H1.61A1.318,1.318,0,0,1,2.919,3.8L4.732,19.215a6.588,6.588,0,0,0,6.543,5.82h13.76a1.318,1.318,0,1,0,0-2.635H11.275a3.953,3.953,0,0,1-3.728-2.636H23.265a6.588,6.588,0,0,0,6.484-5.419,1.318,1.318,0,0,0-1.063-1.53Z",
    fill: "#fff"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgShoppingCartWhite);
export default __webpack_public_path__ + "static/media/shoppingCartWhite.8a8cca732a8d5186c77507c27c409078.svg";
export { ForwardRef as ReactComponent };